const LoadingSpinner = () => (
    <div className="flex justify-center items-center h-64">
      <div className="loader ease-linear rounded-full border-8 border-t-8 border-gray-200 h-16 w-16 animate-spin"></div>
    </div>
  );

export default LoadingSpinner;